'use client';

import { each as _each, isEmpty as _isEmpty } from 'lodash-es';
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { makeStyles } from 'tss-react/mui';
import PrimaryFilter from './primary-filter';
import { filterableRoute } from '../../utils/routes';
import type { Category } from '../../types/Event/Category';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    '& > *': {
      marginBottom: theme.spacing(1),
      '&:not(:last-child)': {
        marginRight: theme.spacing(1),
      },
    },
  },
}));

const defaultFilters: CalendarFilters = {
  filter: 'upcoming',
};

export type CalendarFilters = {
  filter?: 'upcoming' | 'rsvp' | 'managed' | 'drafts' | 'recent' | 'past';
  type?: string;
  categoryIds?: Category[] | null;
  startDate?: string | null;
};

type Props = {
  basePath: string;
  baseHref?: string;
  baseAs?: string;
  tab: string;
  filters: CalendarFilters;
};

const CalendarFilterBar = ({ basePath, baseHref, baseAs, tab, filters }: Props) => {
  const { classes } = useStyles();
  const router = useRouter();

  const handleChange = useCallback((attribute: string, value: unknown) => {
    const newQuery: Record<string, unknown> = { ...filters };
    newQuery[attribute] = value;
    _each(Object.keys(newQuery), (key) => {
      // need isEmpty check because for some reason empty arrays don't ====
      if (newQuery[key] === defaultFilters[key] || _isEmpty(newQuery[key])) {
        delete newQuery[key];
      }
    });
    if (baseHref) {
      router.push(filterableRoute(`${baseAs}${basePath}`, newQuery));
    } else {
      router.push(filterableRoute(basePath, newQuery));
    }
  }, [filters, baseHref, baseAs, basePath, router]);

  return (
    <div className={classes.wrapper}>
      {tab !== 'grid' && (
        <PrimaryFilter
          value={filters.filter || defaultFilters.filter}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

export default CalendarFilterBar;
